<template>
    <div>
        <v-checkbox style="width: auto !important" @click="emitState()" :color="entityConfig.primaryColor" v-model="checked">
            <template v-slot:label>
                <div v-html="checkboxData.label" @click.stop></div>
            </template>
        </v-checkbox>
    </div>
</template>

<script>
export default {
    props:  {
        checkboxData: {
            type: Object,
            default() {
                return { type: 'raw-html' }
            }
        },
    },
    data: () => ({
        checked: false,
        entityConfig: {},
    }),
    mounted() {
        this.entityConfig = this.$store.state.entityConfig.config;
    },
    methods: {
        emitState() {
            let state = this.checked ? "accepted" : "canceled";
            this.$emit(state);
        }
    }
}
</script>